// 디렉토리(directive) 진입점, 해당 디렉토리 참조시 첫번째로 수행될 파일.
// 코드 구조와 모듈화에 이로울 목적으로 사용.
// 가독성&유지보수 향상
require('./customDirective');